import { Breadcrumb } from '../../types';

export const ngoBreadcrumbs: Map<string, Breadcrumb> = new Map([
	['plans', { name: 'plans', to: '/ngo/plans', i18nKey: 'breadcrumb.ngoPlan' }],
	['editPlan', { name: 'editPlan', i18nKey: 'breadcrumb.ngoEditPlan' }],
	['newPlan', { name: 'newPlan', i18nKey: 'breadcrumb.ngoNewPlan' }],
	[
		'products',
		{
			name: 'products',
			to: '/ngo/products',
			i18nKey: 'breadcrumb.ngoProduct',
		},
	],
	[
		'staff',
		{ name: 'staff', to: '/ngo/staff', i18nKey: 'breadcrumb.ngoStaff' },
	],
	[
		'newStaff',
		{
			name: 'newStaff',
			to: '/ngo/staff/new',
			i18nKey: 'breadcrumb.ngoNewStaff',
		},
	],
	[
		'editStaff',
		{
			name: 'editStaff',
			to: '/ngo/staff',
			i18nKey: 'breadcrumb.ngoEditStaff',
		},
	],
	[
		'userRole',
		{
			name: 'userRole',
			to: '/ngo/staff/role',
			i18nKey: 'breadcrumb.userRole',
		},
	],
	[
		'ngoProfile',
		{
			name: 'ngoProfile',
			to: '/ngo/profile',
			i18nKey: 'breadcrumb.ngoProfile',
		},
	],
	[
		'centers',
		{
			name: 'centers',
			to: '/ngo/centers',
			i18nKey: 'breadcrumb.ngoCenters',
		},
	],
	[
		'editCenter',
		{
			name: 'editCenter',
			to: '/ngo/centers',
			i18nKey: 'breadcrumb.ngoEditCenter',
		},
	],
	[
		'newCenter',
		{
			name: 'editCenter',
			to: '/ngo/centers',
			i18nKey: 'breadcrumb.ngoNewCenter',
		},
	],
	[
		'appBannerList',
		{
			name: 'App Banner List',
			to: '/ngo/app-banners',
			i18nKey: 'breadcrumb.appBannerList',
		},
	],
	[
		'newAppBanner',
		{
			name: 'New app banner',
			i18nKey: 'breadcrumb.newAppBanner',
		},
	],
	[
		'editAppBanner',
		{
			name: 'Edit app banner',
			i18nKey: 'breadcrumb.editAppBanner',
		},
	],
	[
		'partnerList',
		{
			name: 'Partner List',
			to: '/ngo/partner-list',
			i18nKey: 'breadcrumb.partnerList',
		},
	],
	[
		'addPartnerList',
		{
			name: 'addPartners',
			to: '/ngo/partner-list/add',
			i18nKey: 'breadcrumb.addPartners',
		},
	],
	[
		'donations',
		{
			name: 'donations',
			to: '/ngo/donations',
			i18nKey: 'breadcrumb.donations',
		},
	],
]);
